import { useContext, useEffect, useState } from 'react'
import Layout from '../../Component/layout/main-layout'
import { Link } from 'react-router-dom'
import { GetConstitution } from '../../api/Queries/get'
import pdf from '../../Images/icons/pdfdownload.svg'
import { useTranslation } from 'react-i18next';
import Loading from '../../Component/loader/loader';
import { Context } from '../../Store/context';
import LawsLayout from '../../Component/layout/laws-layout'
import layoutBgImg from '../../Images/layout/laws.png'
import GlobalLayout from '../../Component/layout/global-layout'

const Constitutions = () => {
    const [constitutions, setConstitutions] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const { t, i18n } = useTranslation();
    const { showError } = useContext(Context);

    const getLawName = (laws) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return laws.rus_name;
        } else if (currentLang === 'en') {
            return laws.eng_name;
        }
        return laws.tm_name;
    };

    const getPdfUrl = (laws) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return laws.rus_pdf;
        } else if (currentLang === 'en') {
            return laws.eng_pdf;
        }
        return laws.tm_pdf;
    };

    useEffect(() => {
        setIsLoading(true)
        const getConstitution = async () => {
            try {
                const data = await GetConstitution()
                setIsLoading(false)
                setConstitutions(data)
            } catch (error) {
                showError(error.message);
                setIsLoading(false)
            }
        }
        getConstitution()
    }, [showError])


    return (
        <GlobalLayout
            title={`${t('tm_constitution')} - ${t('supreme_court')} ${t('turkmenistan')}`}
            keywords="Нормативные правовые акты, Kadalaşdyryjy hukuk namalar, 
            Ygtyyarnama, Ygtyýarnama, Kanun, Konstitusiýa, Konstitusiýa, Kodeks, Hukuk"
            >
            <div className='mb-20'>
                <Layout
                    title={t('laws_codes')}
                    page={t('tm_constitution')}
                    layoutBgImg={layoutBgImg}
                />
                <LawsLayout />

                <main className='media'>
                    <ul className='p-4 xl:p-8 bg-white dark:bg-dark-border'>

                        <p className='text-primary text-xl font-bold 
                                  dark:text-dark-text mb-6'>
                            {t('tm_constitution')}
                        </p>

                        {isLoading ? <Loading /> :
                            constitutions?.map((cons) => (
                                <li key={cons.id}
                                    className='bg-gray dark:bg-dark-box dark:text-dark-text 
                                           flex justify-between items-center p-4 mt-4'>
                                    <Link to={`/constitution/${cons.id}`} className='w-[90%]'>
                                        <p>
                                            {getLawName(cons)}
                                        </p>
                                    </Link>
                                    <a
                                        href={getPdfUrl(cons)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className='flex justify-end w-8 h-8'
                                    >
                                        <img src={pdf} alt="PDF" className='w-full h-full' />
                                    </a>
                                </li>

                            ))}
                        {isLoading ? '' : constitutions.length === 0 && ''}
                    </ul>
                </main>
            </div>
        </GlobalLayout>
    )
}

export default Constitutions